'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _connectorForm = require('./../connector-form');

var _connectorForm2 = _interopRequireDefault(_connectorForm);

var _connectorInchForm = require('./../connector-inch-form');

var _connectorInchForm2 = _interopRequireDefault(_connectorInchForm);

var _productSelector = require('./../product-selector');

var _productSelector2 = _interopRequireDefault(_productSelector);

var _pdfLinks = require('./../pdf-links');

var _pdfLinks2 = _interopRequireDefault(_pdfLinks);

var _advancedFetch = require('../../advanced-fetch');

var _advancedFetch2 = _interopRequireDefault(_advancedFetch);

var _i18n = require('./../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _calculator = require('./calculator.scss');

var _calculator2 = _interopRequireDefault(_calculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_reactI18next.translate.setI18n(_i18n2.default);

var defaultRange = {
    min: 0,
    max: 0
};

var defaultKT = 73;

var defaultData = {
    material: -1,
    weight: '-',
    eh: '',
    z1: '',
    z2: '',
    z3: '',
    m: '',
    tb: '',
    kt1: '',
    s: ''
};

/**
 * Shows calculator for all product types
 */

var Calculator = function (_React$Component) {
    _inherits(Calculator, _React$Component);

    function Calculator(props) {
        _classCallCheck(this, Calculator);

        var _this = _possibleConstructorReturn(this, (Calculator.__proto__ || Object.getPrototypeOf(Calculator)).call(this, props));

        _this.key = _this.props.location.pathname.replace(/\//, '');

        _this.state = {
            showProductSelector: false,
            showPDFLinks: false,
            showNoProductMessage: false,
            enableCalculateButton: false,
            title: '',
            materials: [],
            insertWeight: true,
            data: _.clone(defaultData),
            fieldsConfig: {
                z1: {
                    range: defaultRange
                },
                z2: {
                    range: defaultRange
                },
                z3: {
                    range: defaultRange
                },
                eh: {
                    range: defaultRange
                },
                tb: {
                    range: defaultRange
                },
                s: {
                    range: defaultRange
                },
                kt1: {
                    range: {
                        min: defaultKT
                    }
                }
            },
            invalidFields: [],
            unit: 'mm'
        };

        _this.reset = _this.reset.bind(_this);
        _this.saveInputValues = _this.saveInputValues.bind(_this);
        _this.onValueChange = _this.onValueChange.bind(_this);
        _this.onMaterialChange = _this.onMaterialChange.bind(_this);
        _this.onProductChange = _this.onProductChange.bind(_this);
        _this.switchUnits = _this.switchUnits.bind(_this);
        return _this;
    }

    /**
     *
     */


    _createClass(Calculator, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.check();
        }

        /**
         *
         * @returns {*}
         */

    }, {
        key: 'render',
        value: function render() {
            var productSelector = '',
                pdfLinks = '';

            var t = this.props.t;


            var labels = {
                mm: {
                    calculate: t('Calculate weight class'),
                    material: t('Material'),
                    weight: t('Weight in kg/m3'),
                    eh: t('Installation height in mm'),
                    tb: t('Door width in mm'),
                    s: t('Door thickness in mm'),
                    z1: t('Top air gap in mm'),
                    z2: t('Bottom air gap in mm'),
                    z3: t('Side air gap in mm'),
                    kt1: t('Cabinet depth in mm'),
                    m: t('Door overlap in mm'),
                    pleaseChoose: t('Please choose:')
                },
                inch: {
                    calculate: t('Calculate weight class'),
                    material: t('Material'),
                    weight: t('Weight in pounds'),
                    eh: t('Installation height in inches'),
                    tb: t('Door width in inches'),
                    s: t('Door thickness in inches'),
                    z1: t('Top air gap in inches'),
                    z2: t('Bottom air gap in inches'),
                    z3: t('Side air gap in inches'),
                    kt1: t('Cabinet depth in inches'),
                    m: t('Door overlap in inches'),
                    pleaseChoose: t('Please choose:')
                }
            },
                PDFLabels = {
                a4: t('Plan with individual sizes (1 DIN A4 page)'),
                a3: t('Plan with individual sizes (1 DIN A3 page)')
            };

            if (this.state.materials.length > 0) {
                this.state.materials.map(function (object) {
                    object.label = t(object.key);

                    return object;
                });
            }

            if (this.state.invalidFields.length > 0) {
                this.state.invalidFields.map(function (field) {
                    field.label = t(field.message);

                    return field;
                });
            }

            if (this.state.showProductSelector) {
                productSelector = _react2.default.createElement(_productSelector2.default, {
                    updateProduct: this.onProductChange,
                    product: Array.isArray(this.state.data.product) ? '' : this.state.data.product,
                    t: t
                });
            }

            if (this.state.showPDFLinks) pdfLinks = _react2.default.createElement(_pdfLinks2.default, { labels: PDFLabels });

            var mainForm = {
                mm: _react2.default.createElement(_connectorForm2.default, {
                    formKey: this.key,
                    data: this.state.data,
                    materials: this.state.materials,
                    weightDisabled: this.state.insertWeight,
                    config: this.state.fieldsConfig,
                    labels: labels[this.state.unit],
                    materialChange: this.onMaterialChange,
                    reset: this.reset,
                    save: this.saveInputValues,
                    valueChange: this.onValueChange,
                    invalidFields: this.state.invalidFields,
                    buttonDisabled: !this.state.enableCalculateButton
                }),
                inch: _react2.default.createElement(_connectorInchForm2.default, {
                    formKey: this.key,
                    data: this.state.data,
                    materials: this.state.materials,
                    weightDisabled: this.state.insertWeight,
                    config: this.state.fieldsConfig,
                    labels: labels[this.state.unit],
                    materialChange: this.onMaterialChange,
                    reset: this.reset,
                    save: this.saveInputValues,
                    valueChange: this.onValueChange,
                    invalidFields: this.state.invalidFields,
                    buttonDisabled: !this.state.enableCalculateButton
                })
            };

            var switchLabel = this.state.unit === 'inch' ? 'Switch to mm' : 'Switch to inch';

            return _react2.default.createElement(
                'div',
                { className: 'comp-calucluator' },
                _react2.default.createElement(
                    'div',
                    { className: 'grid-x ' + _calculator2.default['relative-grid'] },
                    _react2.default.createElement(
                        'div',
                        { className: 'cell small-12 medium-10 large-9' },
                        _react2.default.createElement(
                            'a',
                            { className: 'back-link', href: '/', onClick: this.reset },
                            t('Back')
                        ),
                        _react2.default.createElement(
                            'h1',
                            null,
                            t(this.state.title)
                        )
                    ),
                    _react2.default.createElement(
                        'a',
                        { className: _calculator2.default['switch-unit'], href: '/', onClick: this.switchUnits },
                        t(switchLabel)
                    )
                ),
                mainForm[this.state.unit],
                _react2.default.createElement(
                    'div',
                    { className: 'grid-x space-3' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cell small-12 medium-8 large-7' },
                        productSelector
                    )
                ),
                this.state.data.product && this.state.showPDFLinks ? _react2.default.createElement(
                    'p',
                    null,
                    t('calculated weight class'),
                    ': ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        t(this.state.data.product)
                    )
                ) : null,
                pdfLinks
            );
        }

        /**
         * save data to server
         * @param e
         */

    }, {
        key: 'saveInputValues',
        value: function saveInputValues(e) {
            var _this2 = this;

            e.preventDefault();

            this.setState({ invalidFields: [] });

            fetch('/api' + this.props.location.pathname, {
                credentials: 'include',
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(this.state.data)
            }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                if (response.data.product) {
                    _this2.setState(function (prev) {
                        prev.data.product = response.data.product;

                        return prev;
                    });
                }

                if (response.next) return _this2.decideNext(response.next);
            }).catch(function (err) {
                if (_.get(err, 'error.status') === 422) {
                    _this2.setState({ invalidFields: _.get(err, 'error.invalidFields') });
                } else {
                    _this2.setState(function (prev) {
                        prev.invalidFields.push({
                            message: err.message
                        });

                        return prev;
                    });
                }
                void 0;
            });
        }

        /**
         *
         * @param e
         */

    }, {
        key: 'onValueChange',
        value: function onValueChange(e) {
            var _this3 = this;

            var self = this;

            var target = e.target;

            if (!target) return;

            target.addEventListener('blur', function (event) {
                var target = event.target;
                target.checkValidity();
                self.setState(function (prev) {
                    prev.invalidFields = prev.invalidFields.filter(function (_ref) {
                        var fieldName = _ref.fieldName;
                        return fieldName != event.target.name;
                    });
                    return prev;
                });
            });

            target.addEventListener('valid', function (event) {
                setTimeout(function () {
                    self.setState(function (prev) {
                        prev.invalidFields = prev.invalidFields.filter(function (_ref2) {
                            var fieldName = _ref2.fieldName;
                            return fieldName != event.target.name;
                        });

                        return prev;
                    });
                }.bind(_this3), 50);
            });

            target.addEventListener('invalid', function (event) {
                setTimeout(function () {
                    self.setState(function (prev) {
                        prev.invalidFields = prev.invalidFields.filter(function (_ref3) {
                            var fieldName = _ref3.fieldName;
                            return fieldName != event.target.name;
                        });
                        prev.invalidFields.push({
                            fieldName: event.target.name,
                            message: 'The value of this field is out of range.'
                        });

                        return prev;
                    });
                }.bind(_this3), 50);
            });

            this.setState(function (prev) {
                prev.data[target.name] = target.internalValue || target.value;

                prev.enableCalculateButton = _this3.buttonEnabled(prev.data);

                return prev;
            });
        }

        /**
         * set the weight on the material according to the selection
         *
         * @param e
         */

    }, {
        key: 'onMaterialChange',
        value: function onMaterialChange(e) {
            var _this4 = this;

            var target = e.target;

            if (!target) return;

            this.setState(function (prev) {
                prev.data.material = target.value;

                var val = prev.materials.filter(function (entry) {
                    return entry.key === prev.data.material;
                });

                val = val[0] || { weight: '-' };

                prev.data.weight = val.weight || '';
                prev.insertWeight = !!prev.data.weight;

                prev.enableCalculateButton = _this4.buttonEnabled(prev.data);

                return prev;
            });
        }

        /**
         *
         * @param product
         */

    }, {
        key: 'onProductChange',
        value: function onProductChange(product) {
            var _this5 = this;

            fetch('/api/update-product', {
                credentials: 'include',
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ product: product })
            }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                _this5.setState(function (prev) {
                    prev.data.product = product;
                    prev.showPDFLinks = true;

                    return prev;
                });
            }).catch(function (err) {
                void 0;
            });
        }

        /**
         * Enable button if all fields are filled
         *
         * @param data
         * @returns {boolean}
         */

    }, {
        key: 'buttonEnabled',
        value: function buttonEnabled(data) {
            var mandatory = ['eh', 'z1', 'z2', 'z3', 'm', 'tb', 'kt1', 's'];

            var fulfilled = mandatory.every(function (key) {
                return !!data[key];
            });

            if (!fulfilled) return false;

            if (data.material === -1) return false;

            if (data.material === 'other') return !!data.weight;

            return true;
        }

        /**
         *
         * @param e
         */

    }, {
        key: 'switchUnits',
        value: function switchUnits(e) {
            var _this6 = this;

            e.preventDefault();
            var unit = this.state.unit === 'mm' ? 'inch' : 'mm';

            fetch('/api/update-units', {
                credentials: 'include',
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' },
                body: JSON.stringify({ unit: unit })
            }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                _this6.setState(function (prev) {
                    prev.data = _.clone(defaultData);
                    prev.data.unit = unit;
                    prev.invalidFields = [];
                    prev.showPDFLinks = false;
                    prev.showProductSelector = false;

                    return prev;
                }, _this6.check);
            });
        }

        /**
         * check if it is the turn of this component to be shown
         */

    }, {
        key: 'check',
        value: function check() {
            var _this7 = this;

            fetch('/api' + this.props.location.pathname, { credentials: 'include', headers: { Pragma: 'no-cache' } }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                if (response.next) {
                    var proceed = _this7.decideNext(response.next);

                    if (!proceed) return;
                }

                if (!response.config) return;

                _this7.setState(function (prev) {
                    prev.title = response.config.title;

                    return prev;
                });

                // store validation values for number inputs
                if (response.config.validations) {
                    _this7.setState(function (prev) {
                        prev.fieldsConfig = _.assign(prev.fieldsConfig, response.config.validations);

                        return prev;
                    });
                }

                // if data is sent: set data
                if (response.data) {
                    _this7.setState(function (prev) {
                        prev.data = _.merge(prev.data, response.data);
                        prev.enableCalculateButton = _this7.buttonEnabled(prev.data);
                        prev.unit = response.data.unit || prev.unit;

                        return prev;
                    });

                    // load materials at if we do not receive a next information. Prevent setState on unmounted
                    // component
                    return _this7.load();
                }

                // else set default values
                if (response.config.constants.defaults) {
                    _this7.setState(function (prev) {
                        prev.data = _.merge(prev.data, response.constants.defaults);

                        return prev;
                    });

                    // load materials at if we do not receive a next information. Prevent setState on unmounted
                    // component
                    return _this7.load();
                }
            });
        }

        /**
         * loads material from server
         *
         * @returns {Promise<Response>}
         */

    }, {
        key: 'load',
        value: function load() {
            var _this8 = this;

            return fetch('/api/concepta-material', { credentials: 'include', headers: { 'Pragma': 'no-cache' } }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                _this8.setState(function (prev) {
                    prev.materials = response.materials.map(function (entry) {
                        return { label: entry.key, key: entry.key, weight: entry.value };
                    });

                    return prev;
                });
            });
        }

        /**
         *
         * @param next
         */

    }, {
        key: 'decideNext',
        value: function decideNext(next) {
            if (next === '/select-product') {
                this.setState(function (prev) {
                    prev.showProductSelector = true;
                    prev.showPDFLinks = false;
                    prev.data.product = '';

                    return prev;
                });

                return true;
            }

            if (next === '/pdf') {
                this.setState(function (prev) {
                    prev.showPDFLinks = true;
                    prev.showProductSelector = false;
                    return prev;
                });

                return true;
            }

            if (next === '/no-product') {
                this.setState(function (prev) {
                    prev.showProductSelector = false;
                    prev.showPDFLinks = false;
                    prev.showNoProductMessage = true;
                    prev.invalidFields.push({
                        message: 'No configuration possible for the entered dimensions. Please adjust the installation height (EH) or the door width (TB).'
                    });
                    return prev;
                });

                return true;
            }

            this.props.history.push(next);

            return false;
        }

        /**
         * Reset the calculator
         *
         * @param e
         */

    }, {
        key: 'reset',
        value: function reset(e) {
            var _this9 = this;

            e.preventDefault();

            fetch('/api/reset', {
                credentials: 'include',
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' }
            }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                _this9.props.history.push(response.next);
            }).catch(function (err) {
                void 0;
            });
        }
    }]);

    return Calculator;
}(_react2.default.Component);

Calculator.propTypes = {
    history: _propTypes2.default.object.isRequired,
    location: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactI18next.translate)([])(Calculator);


//////////////////
// WEBPACK FOOTER
// ./client/components/caluculator/index.js
// module id = 483
// module chunks = 0